import React from "react";
import Link from "gatsby-link";
import styled from "styled-components";

import ProjectItem from "../components/ProjectItem";
import ExternalLink from "../components/ExternalLink";

import bkmrk from "../assets/bkmrk.svg";
import ccgm from "../assets/ccgm.svg";
import decksettuner from "../assets/decksettuner.svg";
import growler from "../assets/growler.svg";
import hotels from "../assets/hotels.svg";
import localweather from "../assets/localweather.svg";
import ptrs from "../assets/ptrs.svg";
import sharity from "../assets/sharity.svg";
import wahl from "../assets/wahl.svg";

const projects = [
  {
    title: "Bkmrk",
    subtitle: "Web App",
    url: "/projects/bkmrk",
    image: bkmrk
  },
  {
    title: "CCGM Stiftung",
    subtitle: "Non Profit Website",
    url: "/projects/ccgm-stiftung",
    image: ccgm
  },
  {
    title: "Decksettuner",
    subtitle: "IOT Project",
    url: "/projects/decksettuner",
    image: decksettuner
  },
  {
    title: "Growler",
    subtitle: "Web App",
    url: "/projects/growler",
    image: growler
  },
  {
    title: "Hotels",
    subtitle: "Wordpress Theme",
    url: "/projects/hotels",
    image: hotels
  },
  {
    title: "Local Weather",
    subtitle: "iOS App",
    url: "/projects/localweather",
    image: localweather
  },
  {
    title: "Pestalozzi Realschule",
    subtitle: "Relaunch Website",
    url: "/projects/pestalozzi-realschule",
    image: ptrs
  },
  {
    title: "Sharity Online",
    subtitle: "Web App",
    url: "/projects/sharity-online",
    image: sharity
  },
  {
    title: "Wahl App",
    subtitle: "React Native App",
    url: "/projects/wahl-app",
    image: wahl
  }
];

const IndexPage = () => (
  <div>
    <Wrapper>
      <H1>Hi, I'm Jurek</H1>
      <P>
        I'm a <TextLink to="/about">passionate</TextLink> software engineer in
        Munich. I love{" "}
        <ExternalLink href="https://www.strava.com/athletes/14628162">
          biking
        </ExternalLink>{" "}
        and tech in general.
      </P>
    </Wrapper>
    <Projects>
      {projects.map((el, index) => (
        <ProjectItem key={`key-${index}`} {...el} />
      ))}
    </Projects>
  </div>
);

const TextLink = styled(Link)`
  color: var(--link-color);
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: all 0.1s ease;
  display: inline-block;
  padding-bottom: 0.1em;
  &:hover,
  &:focus {
    border-bottom: 2px solid var(--link-color);
  }
`;

const Projects = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Wrapper = styled.div`
  max-width: 52em;
  padding: 0 1em;
  margin: 6em auto;
`;

const P = styled.p`
  font-size: 1.5em;
`;
const H1 = styled.h1``;

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js